



















import { Vue, Component, Watch } from 'vue-property-decorator'
import { Style } from 'ol/style'
import { Actualite } from '@/orrm/model/actualite'
import { InfoReglementation } from '@/orrm/model/info-reglementation'
import { Entity } from '@/orrm/model/entity'
import { context, map } from '@/store/modules'
import { TileWMS } from 'ol/source'

@Component
export default class Legend extends Vue {
  legends: { url?: string; fallbackUrl?: string; label: string }[] = []
  featuresStyles: { [label: string]: Style } = {
    Actualités: Actualite.featureStyle,
    'Infos & Règlementations locales': InfoReglementation.featureStyle,
    Entités: Entity.featureStyle
  }

  get featuresStylesKeys (): string[] {
    return Object.keys(this.featuresStyles)
  }

  get resolution (): number {
    return map.resolution
  }

  getCSS (style: Style): string {
    const css: string[] = []

    const fillColor = style.getFill().getColor() as number[] | string
    const bgColor = Array.isArray(fillColor) ? `rgb(${fillColor.join(',')})` : fillColor
    css.push(`background-color: ${bgColor};`)

    const strokeColor = style.getStroke().getColor() as number[] | string
    const strokeWidth = style.getStroke().getWidth()
    const borderColor = Array.isArray(strokeColor) ? `rgb(${strokeColor.join(',')})` : strokeColor
    css.push(`border: solid ${borderColor} ${strokeWidth}px`)

    return css.join('; ')
  }

  filterLegendParams (params: { [key: string]: any }) {
    const allowedParams = ['REQUEST', 'LAYER', 'STYLE', 'FEATURETYPE', 'RULE', 'SCALE', 'SLD', 'SLD_BODY', 'FORMAT', 'SLD_VERSION', 'WIDTH', 'HEIGHT', 'EXCEPTIONS', 'LANGUAGE']
    const filteredFilters: { [key: string]: any } = {}

    for (const param of Object.keys(params)) {
      if (allowedParams.indexOf(param.toUpperCase()) !== -1) {
        filteredFilters[param] = params[param]
      }
    }
    return filteredFilters
  }

  @Watch('resolution', { immediate: true })
  onResolutionChanged () {
    if (context.activeContext) {
      this.legends.splice(0, this.legends.length)
      for (const layer of context.activeContext.layers) {
        const source = layer.olLayer.getSource()
        if (source instanceof TileWMS) {
          const inputParams = layer.model.params ? JSON.parse(layer.model.params) || {} : {}
          const guessedParams = layer.guessParams(layer.model.flux?.value || '')
          const params = {
            SLD_VERSION: '1.1.0',
            ...guessedParams,
            ...inputParams
          }

          const paramLayers = params.layers || params.LAYERS
          if (paramLayers) {
            const layerNames: string[] = paramLayers.split(',').map((layer: string) => layer.trim())
            for (const layerName of layerNames) {
              const filteredParams = this.filterLegendParams({ ...params, layer: layerName })
              this.legends.push({
                url: (source as TileWMS).getLegendUrl(this.resolution, filteredParams),
                fallbackUrl: (source as TileWMS).getLegendUrl(this.resolution, { ...filteredParams, SCALE: undefined }),
                label: layer.model.title
              })
            }
          } else {
            const filteredParams = this.filterLegendParams(params)
            this.legends.push({
              url: (source as TileWMS).getLegendUrl(this.resolution, filteredParams),
              fallbackUrl: (source as TileWMS).getLegendUrl(this.resolution, { ...filteredParams, SCALE: undefined }),
              label: layer.model.title
            })
          }
        }
      }
    }
  }
}
